// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const gateLamp = defineModel({
  id: "gate-lamp",
  batchId: "future",
  name: "Gate lamp",
  tags: ["scenery","gate","lamp","low-poly","age-of-mcp","future"],
  summary: "A gate lamp — lights an entrance or gateway.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.2,
  parts: () => [
      { geometry: new THREE.BoxGeometry(0.22, 0.5, 0.22), color: "#9a9183", position: [0, 0.25, 0] },
      { geometry: new THREE.BoxGeometry(0.28, 0.06, 0.28), color: "#79715f", position: [0, 0.03, 0] },
      { geometry: new THREE.BoxGeometry(0.27, 0.05, 0.27), color: "#79715f", position: [0, 0.52, 0] },
      { geometry: new THREE.BoxGeometry(0.23, 0.04, 0.23), color: "#675f50", position: [0, 0.56, 0] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.08, 0.03, 6), color: "#2f343a", position: [0, 0.59, 0] },
      { geometry: new THREE.BoxGeometry(0.12, 0.18, 0.12), color: "#ffe4aa", position: [0, 0.7, 0] },
      { geometry: new THREE.SphereGeometry(0.05, 7, 6), color: "#fff2cc", position: [0, 0.7, 0] },
      { geometry: new THREE.BoxGeometry(0.012, 0.18, 0.012), color: "#2f343a", position: [-0.06, 0.7, -0.06] },
      { geometry: new THREE.BoxGeometry(0.012, 0.18, 0.012), color: "#2f343a", position: [0.06, 0.7, -0.06] },
      { geometry: new THREE.BoxGeometry(0.012, 0.18, 0.012), color: "#2f343a", position: [-0.06, 0.7, 0.06] },
      { geometry: new THREE.BoxGeometry(0.012, 0.18, 0.012), color: "#2f343a", position: [0.06, 0.7, 0.06] },
      { geometry: new THREE.SphereGeometry(0.08, 8, 5, 0, 6.283185, 0, 1.570796), color: "#23272b", position: [0, 0.79, 0] },
      { geometry: new THREE.SphereGeometry(0.018, 5, 4), color: "#2f343a", position: [0, 0.87, 0] },
    ],
  animations: [],
});
